import {
  colors,
  getThemeWithMedia,
  DarkTheme,
  Link,
  Text,
} from "@a0/quantum-web";
import { ThemeProvider } from "styled-components";
import mediaSizes from "../shared/mediaSizes";
import dictionary from "./dictionary";
import * as S from "./styled";

export const InHouseFooter = () => (
  <ThemeProvider theme={getThemeWithMedia(DarkTheme, mediaSizes)}>
    <S.MainWrapper>
      <S.BottomNavWrapper>
        <S.BottomContainer role="navigation">
          <Text
            type="Paragraph"
            size="xsmall"
            styleOverrides={{
              color: colors.neutral_n100,
              margin: 0,
            }}
          >
            {dictionary.bottom.rights}
          </Text>
          <S.Links role="menubar">
            {dictionary.bottom.links.map((link) => (
              <S.LinkWrapper key={link.text} role="menuitem">
                <Link
                  href={link.url}
                  size="xsmall"
                  styleOverrides={{
                    color: colors.neutral_n100,
                    "text-decoration": "none",
                  }}
                >
                  {link.text}
                </Link>
              </S.LinkWrapper>
            ))}
          </S.Links>
        </S.BottomContainer>
      </S.BottomNavWrapper>
    </S.MainWrapper>
  </ThemeProvider>
);
